import classNames from 'classnames';
import React from 'react';
import { toast, ToastOptions } from 'react-toastify';
import styled from 'styled-components';
import { Success } from 'components/Icons/Success';

const SuccessToast = styled.div`
  display: flex;
  align-items: center;
  line-height: 16px;
  svg {
    margin-right: 8px;
    flex-shrink: 0;
  }

  span {
    word-break: break-word;
  }
`;

export const showSuccess = (message: string, options: ToastOptions = {}) => {
  if (options.autoClose === false) {
    options.className = classNames(options.className || '', 'toast-with-close');
  }
  return toast.success(
    <SuccessToast>
      <Success />
      <span>{message}</span>
    </SuccessToast>,
    options,
  );
};
